import axios from "axios"

export const setService = async (ondemand, body) => {
	try {
		const request = await axios.post(`${process.env.REACT_APP_REPOURL}/v1/repo_aden/ondemand/update/${ondemand}`, body)
		return request.data
	} catch (error) {
		return { error }
	}
}